// esicEmployee.actions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';
import {
    CreateESICEmployeePayload,
    UpdateESICEmployeePayload,
    ESICEmployee,
    CreateSuccessResponse
} from './employeemappingType';


// Create
export const createEsicEmployee = createAsyncThunk<ESICEmployee, CreateESICEmployeePayload>(
    'esicEmployee/create',
    async (employeeData, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.post('/esic-employee', employeeData);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create ESIC employee');
        }
    }
);



// Fetch All
export const fetchEsicEmployees = createAsyncThunk<ESICEmployee[]>(
    'esicEmployee/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get('/esic-employee');
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch ESIC employees');
        }
    }
);

// Fetch By ID
export const fetchEsicEmployeeById = createAsyncThunk<ESICEmployee, number>(
    'esicEmployee/fetchById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get(`/esic-employee/${id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch ESIC employee');
        }
    }
);


// Updated return type from void to ESICEmployee
export const updateEsicEmployee = createAsyncThunk<ESICEmployee, UpdateESICEmployeePayload>(
    'esicEmployee/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
          
            const response = await payrollServiceApiInstance.put(`/esic-employee/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update ESIC employee');
        }
    }
);

// Delete
export const deleteEsicEmployee = createAsyncThunk<number, number>(
    'esicEmployee/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.delete(`/esic-employee/${id}`);
            return id;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete ESIC employee');
        }
    }
);